import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ControllableStates from './ControllableStates';
import ClientProvider from './client';
export default createDemo(import.meta.url, ControllableStates, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/autocomplete/demos/controllable-states/ControllableStates.tsx",
    "fileName": "ControllableStates.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport TextField from '@mui/material/TextField';\nimport Autocomplete from '@mui/material/Autocomplete';\n\nconst options = ['Option 1', 'Option 2'];\n\nexport default function ControllableStates() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [value, setValue] = React.useState<string | null>(options[0]);\n  const [inputValue, setInputValue] = React.useState('');\n\n  return (\n    <div>\n      <div>{`value: ${value !== null ? `'${value}'` : 'null'}`}</div>\n      <div>{`inputValue: '${inputValue}'`}</div>\n      <br />\n      <Autocomplete\n        value={value}\n        onChange={(event: any, newValue: string | null) => {\n          setValue(newValue);\n        }}\n        inputValue={inputValue}\n        onInputChange={(event, newInputValue) => {\n          setInputValue(newInputValue);\n        }}\n        id=\"controllable-states-demo\"\n        options={options}\n        sx={{ width: 300 }}\n        renderInput={(params) => <TextField {...params} label=\"Controllable\" />}\n      />\n    </div>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 32,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport TextField from '@mui/material/TextField';\nimport Autocomplete from '@mui/material/Autocomplete';\n\nconst options = ['Option 1', 'Option 2'];\n\nexport default function ControllableStates() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const [value, setValue] = React.useState<string | null>(options[0]);\n  const [inputValue, setInputValue] = React.useState('');\n\n  return (\n    <div>\n      <div>{`value: ${value !== null ? `'${value}'` : 'null'}`}</div>\n      <div>{`inputValue: '${inputValue}'`}</div>\n      <br />\n      <Autocomplete\n        value={value}\n        onChange={(event: any, newValue: string | null) => {\n          setValue(newValue);\n        }}\n        inputValue={inputValue}\n        onInputChange={(event, newInputValue) => {\n          setInputValue(newInputValue);\n        }}\n        id=\"controllable-states-demo\"\n        options={options}\n        sx={{ width: 300 }}\n        renderInput={(params) => <TextField {...params} label=\"Controllable\" />}\n      />\n    </div>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 32,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/TextField",
      "@mui/material/Autocomplete"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
